import { render, staticRenderFns } from "./vip_points_system.vue?vue&type=template&id=f871b8f8&"
import script from "./vip_points_system.vue?vue&type=script&lang=js&"
export * from "./vip_points_system.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports